import { z } from "zod";
export const WorkspaceUntypedData = z.object({
    id: z.string(),
    workspaceId: z.string(),
    value: z.unknown(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
